const messages = {
  name: 'Centro de Coste |||| Centros de Coste',
  fields: {
    name: 'Nombre del Centro de Coste',
    description: 'Descripcion',
    creditBalance: 'Saldo de Creditos',
    availableCredits: 'Saldo de Creditos',
    reservedCredits: 'Creditos Reservados',
    unpaidCreditLimit: 'Limite de Credito Impagado',
  },
  empty: 'No hay centros de coste',
  invite: 'Anade tu primer centro de coste',
  filters: {
    costCenterName: 'Nombre del Centro de Coste',
  },
  columns: {
    actions: 'Acciones',
    status: 'Estado',
  },
  status: {
    active: 'Activo',
    blocked: 'Bloqueado',
  },
  actions: {
    addCostCenter: 'Anadir Centro de Coste',
    creditTransactions: 'Transacciones de credito',
    viewAccounts: 'Ver cuentas',
    topUp: 'Recargar',
    adjust: 'Ajustar saldo',
    block: 'Bloquear',
    unblock: 'Desbloquear',
    delete: 'Eliminar',
  },
  accountsDialog: {
    title: 'Cuentas de "%{name}"',
    empty: 'Este centro de coste no tiene cuentas.',
    count: '%{smart_count} cuenta |||| %{smart_count} cuentas',
  },
  notificationsExtra: {
    blockSucceeded: 'Saldo bloqueado',
    blockFailed: 'No se pudo bloquear el saldo',
    unblockSucceeded: 'Saldo desbloqueado',
    unblockFailed: 'No se pudo desbloquear el saldo',
  },
  dialog: {
    title: 'Detalles del Centro de Coste',
  },
  validation: {
    required: '%{field} es obligatorio',
    maxLength: '%{field} debe tener como maximo %{max} caracteres',
    minValue: '%{field} debe ser mayor o igual a %{min}',
    positive: '%{field} debe ser mayor que 0',
  },
  create: { title: 'Crear Centro de Coste' },
  edit: { title: 'Editar Centro de Coste' },
  sections: {
    basicInfo: 'Detalles del Centro de Coste',
  },
  delete: {
    title: 'Eliminar centro de coste "%{recordName}"',
    content: 'Estas seguro de que quieres eliminar este centro de coste? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Centro de Coste creado correctamente',
    updated: 'Centro de Coste actualizado correctamente',
    deleted: 'Centro de Coste eliminado correctamente',
  },
};

export default messages;
